import { useEffect, useState } from 'react';

/**
 * La selezione di un elenco, che vale **solo per le righe che si vedono**.
 *
 * Cambiando pagina, filtro o ricerca, le righe selezionate che spariscono
 * dalla vista escono anche dalla selezione. Prima restavano: si selezionavano
 * due ordini, si cambiava pagina, si premeva «Elimina» sulla pagina nuova e
 * sparivano anche i due di prima, che nessuno aveva più davanti. Un'azione di
 * massa tocca quello che si guarda, nient'altro.
 *
 * Le righe rimaste indietro da un'azione (quelle che si vedono ancora)
 * restano selezionate, come vuole `AzioniDiMassa`.
 */
export function useSelezione(righe: { id: string | number }[] | undefined) {
  const [selezione, setSelezione] = useState<Set<string | number>>(new Set());

  useEffect(() => {
    const visibili = new Set((righe ?? []).map((r) => r.id));
    setSelezione((attuale) => {
      const resta = [...attuale].filter((id) => visibili.has(id));
      return resta.length === attuale.size ? attuale : new Set(resta);
    });
  }, [righe]);

  return [selezione, setSelezione] as const;
}
